var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 5.58a1.942 1.942 0 0 0-3.49 0l-3.896 8.018-8.702 1.285a1.935 1.935 0 0 0-1.558 1.315 1.95 1.95 0 0 0 .48 1.981l6.313 6.248-1.49 8.83a1.945 1.945 0 0 0 2.83 2.036l7.775-4.151 7.775 4.15a1.94 1.94 0 0 0 2.048-.139c.6-.436.903-1.17.782-1.896l-1.497-8.83 6.314-6.248a1.937 1.937 0 0 0 .479-1.981 1.943 1.943 0 0 0-1.557-1.315l-8.708-1.285-3.897-8.017Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.b64484e4823bf2c2f683d165df7ae844.svg";